/** Columns of the bulk-upload example table on the file step. */
import { CellRenderParams, ColumnConfig } from "@ryerson/frontend.table";
import ExampleFileStructureTableHeader from "./ExampleFileStructureTableHeader";
import { BulkUploadModalContent } from "../BulkUploadModalContent";
import ExampleFileStructureTableBasicCell from "./ExampleFileStructureTableBasicCell";
import { BulkUploadType } from "../BulkUpload.model";

/**
 * Column config of the bulk-upload example table (`ExampleFileStructureTable.tsx`). Follows the
 * order and required flags of the map-fields list in `BulkUploadModal.tsx` → `defaultFileData`
 * (the two are separate lists); the delivery-date column is added for cart and quote uploads
 * only. Headers use `BulkUploadModalContent.ts`, not the map-fields labels, so the two wordings
 * can differ (for example "Price Unit Of Measure" here, "Pricing Unit of Measure" there).
 */
export const getExampleFileStructureTableConfig = (
	language: string,
	bulkUploadType: BulkUploadType
): ColumnConfig[] => {
	const content = BulkUploadModalContent[language];

	return [
		{
			id: "partNumber",
			label: "",
			hideColumnCardView: true,
			headerRender: () => (
				<ExampleFileStructureTableHeader
					{...{ headerTitle: content.partNumber, isFieldMandatory: true }}
				/>
			),
			cellRender: ({ itemData }) => <ExampleFileStructureTableBasicCell {...{ itemData }} />,
		},
		{
			id: "quantity",
			label: "",
			hideColumnCardView: true,
			headerRender: () => (
				<ExampleFileStructureTableHeader
					{...{ headerTitle: content.quantity, isFieldMandatory: true }}
				/>
			),
			cellRender: ({ itemData }) => <ExampleFileStructureTableBasicCell {...{ itemData }} />,
		},
		{
			id: "quantityUom",
			label: "",
			hideColumnCardView: true,
			headerRender: () => (
				<ExampleFileStructureTableHeader
					{...{ headerTitle: content.quantityUom, isFieldMandatory: true }}
				/>
			),
			cellRender: ({ itemData }) => <ExampleFileStructureTableBasicCell {...{ itemData }} />,
		},
		{
			id: "priceUom",
			label: "",
			hideColumnCardView: true,
			headerRender: () => (
				<ExampleFileStructureTableHeader {...{ headerTitle: content.priceUom }} />
			),
			cellRender: ({ itemData }) => <ExampleFileStructureTableBasicCell {...{ itemData }} />,
		},
		{
			id: "customerRefNumber",
			label: "",
			hideColumnCardView: true,
			headerRender: () => (
				<ExampleFileStructureTableHeader {...{ headerTitle: content.customerRefNumber }} />
			),
			cellRender: ({ itemData }) => <ExampleFileStructureTableBasicCell {...{ itemData }} />,
		},
		{
			id: "lineLevelPO",
			label: "",
			hideColumnCardView: true,
			headerRender: () => (
				<ExampleFileStructureTableHeader {...{ headerTitle: content.lineLevelPO }} />
			),
			cellRender: ({ itemData }) => <ExampleFileStructureTableBasicCell {...{ itemData }} />,
		},
		{
			id: "lineItemNotes",
			label: "",
			hideColumnCardView: true,
			headerRender: () => (
				<ExampleFileStructureTableHeader {...{ headerTitle: content.lineItemNotes }} />
			),
			cellRender: ({ itemData }) => <ExampleFileStructureTableBasicCell {...{ itemData }} />,
		},
		...([BulkUploadType.shoppingCart, BulkUploadType.quote].includes(bulkUploadType)
			? [
					{
						id: "deliveryDate",
						label: "",
						hideColumnCardView: true,
						headerRender: () => (
							<ExampleFileStructureTableHeader
								{...{ headerTitle: content.deliveryDate }}
							/>
						),
						cellRender: ({ itemData }: CellRenderParams) => (
							<ExampleFileStructureTableBasicCell {...{ itemData }} />
						),
					},
			  ]
			: []),
	];
};
